import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import EditMPPointConfigContext from 'contexts/EditMPPointConfigContext';
import { useTranslation } from 'react-i18next';
import MPPointConfigForm from 'forms/MPPointConfigForm';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedMPPointConfig } = React.useContext(EditMPPointConfigContext);
  if (!selectedMPPointConfig) {
    history.push('/private/admin/payments/mercado-pago-point');
    return <></>;
  }

  return (
    <div>
      <MPPointConfigForm config={selectedMPPointConfig} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
